import script from "./EditWorkspace.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditWorkspace.vue?vue&type=script&setup=true&lang=ts"

import "./EditWorkspace.vue?vue&type=style&index=0&id=0f36093a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f36093a"]])

export default __exports__